import { state } from "Models/Enums";

/**
 * DEFINE TYPES
 */
export type MotorVehicleSearchBy = "Vin" | "RegistrationNumber";
export type MotorVehicleSearchRequest = VinVehicleSearch | RegistrationNumberVehicleSearch;

export interface BaseVehicleSearch {
	searchBy: MotorVehicleSearchBy;
	// vin or registration number
	value: string;
}

export interface VinVehicleSearch extends BaseVehicleSearch {
	searchBy: "Vin";
}

export interface RegistrationNumberVehicleSearch extends BaseVehicleSearch {
	searchBy: "RegistrationNumber";
	state: state;
}

/**
 * DEFINE CONSTANTS
 */
export const MotorVehicleSearchTypeOptions: { [key in MotorVehicleSearchBy]: string } = {
	Vin: "Vin",
	RegistrationNumber: "Vehicle Registration Number"
}

export const AllMvsSearchByOptions = Object.entries(MotorVehicleSearchTypeOptions)
	.map(([key, value]) => ({
		value: key as MotorVehicleSearchBy,
		display: value
	}));


export const MvsVinSearchByDefault: VinVehicleSearch = { searchBy: 'Vin', value: "" };
export const MvsVrnSearchByDefault: RegistrationNumberVehicleSearch = { searchBy: 'RegistrationNumber', value: "", state: "NONE" }
